module.exports = __webpack_public_path__ + "static/img/top-2.30186b9b.png";